const validatePhone = (phone) => phone.length >= 10 && phone.length <= 11;

const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
const validateEmail = (email) => email !== '' && EMAIL_REGEX.test(email);

export {validatePhone, validateEmail};
